import React from "react";
import { motion } from "framer-motion";
import { PILLARS } from "../../data/assessment";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 },
  }),
};

export default function Framework() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: "var(--rtd-bg)", padding: "96px 24px" }}
      data-testid="framework-section"
    >
      <div className="mx-auto" style={{ maxWidth: 680 }}>
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          <p className="eyebrow" style={{ marginBottom: 12 }}>
            What Premium Clinics Do Differently
          </p>
          <h2
            className="font-serif-display"
            style={{ fontSize: 36, color: "var(--rtd-text)", lineHeight: 1.15 }}
          >
            Three changes that shift the patient profile completely.
          </h2>
          <p
            className="font-body"
            style={{
              fontSize: 16,
              color: "var(--rtd-text-secondary)",
              lineHeight: 1.7,
              marginTop: 16,
            }}
          >
            None of these require a bigger budget. They require a different architecture —
            connecting CRM outcomes to the ad platform so the algorithm learns from
            revenue, not form fills.
          </p>
        </motion.div>

        <div className="flex flex-col" style={{ gap: 16, marginTop: 40 }}>
          {PILLARS.map((pillar, i) => (
            <motion.div
              key={pillar.label}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`pillar-card-${i + 1}`}
              style={{
                backgroundColor: "var(--rtd-card)",
                border: "1px solid var(--rtd-border)",
                borderTop: "3px solid var(--rtd-gold)",
                borderRadius: 16,
                padding: 28,
              }}
            >
              <div
                className="font-body"
                style={{
                  fontWeight: 700,
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--rtd-gold)",
                  marginBottom: 8,
                }}
              >
                {pillar.label}
              </div>
              <h3
                className="font-body"
                style={{ fontWeight: 700, fontSize: 17, color: "var(--rtd-text)", lineHeight: 1.35 }}
              >
                {pillar.title}
              </h3>
              <p
                className="font-body"
                style={{
                  fontSize: 14,
                  color: "var(--rtd-text-secondary)",
                  lineHeight: 1.65,
                  marginTop: 12,
                }}
              >
                {pillar.body}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Quote block */}
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          data-testid="framework-quote"
          style={{
            marginTop: 32,
            borderLeft: "3px solid var(--rtd-gold)",
            backgroundColor: "rgba(232,160,32,0.06)",
            borderRadius: "0 8px 8px 0",
            padding: "20px 24px",
          }}
        >
          <p
            className="font-body"
            style={{ fontSize: 15, fontStyle: "italic", color: "#374151", lineHeight: 1.65 }}
          >
            &ldquo;Meta reports 19% lower cost per quality lead with CAPI enabled. When CRM
            data is passed back, the algorithm learns which leads from which audience
            segments actually became patients. This improves both ad delivery and lookalike
            quality simultaneously.&rdquo;
          </p>
          <p
            className="font-body"
            style={{ fontSize: 12, color: "var(--rtd-muted)", marginTop: 12 }}
          >
            LeadSync / Meta Custom Audiences Research, 2026
          </p>
        </motion.div>
      </div>
    </section>
  );
}
